export default __webpack_public_path__ + "static/media/cam_edu_background.440a66a0.jpg";